import $axios from './index' 
export function getTranslateTypeList(data) {
    const url = '/api/smartIsland/manage/getTranslateTypeList'
    return $axios.get(url, data)
}

export function createTranslateType(data) {
  const url = '/api/smartIsland/manage/createTranslateType'
  return $axios.post(url, data)
}

export function updateTranslateType(data) {
  const url = '/api/smartIsland/manage/updateTranslateType'
  return $axios.put(url, data)
}

export function delTranslateType(data) {
  const url = '/api/smartIsland/manage/delTranslateType'
  return $axios.delete(url, data)
}


export function uploadFiles(data) {
  const url = '/api/smartIsland/public/uploadFile'
  return $axios.files(url, data)
}


export function getTranslateList(data) {
  const url = '/api/smartIsland/manage/getTranslateList'
  return $axios.get(url, data)
}
export function createTranslate(data) {
  const url = '/api/smartIsland/manage/createTranslate'
  return $axios.post(url, data)
}
export function updateTranslate(data) {
  const url = '/api/smartIsland/manage/updateTranslate'
  return $axios.put(url, data)
}
export function delTranslate(data) {
  const url = '/api/smartIsland/manage/delTranslate'
  return $axios.delete(url, data)
}


export function getCompanyList(data) {
  const url = '/api/smartIsland/manage/getCompanyList'
  return $axios.get(url, data)
}
export function createCompany(data) {
  const url = '/api/smartIsland/manage/createCompany'
  return $axios.post(url, data)
}
export function updateCompany(data) {
  const url = '/api/smartIsland/manage/updateCompany'
  return $axios.put(url, data)
}
export function delCompany(data) {
  const url = '/api/smartIsland/manage/delCompany'
  return $axios.delete(url, data)
}

export function getZeusCompanyApi(data) {
  const url = '/api/smartIsland/manage/getZeusCompanyApi'
  return $axios.get(url, data)
}

export function createSeriesApi(data) {
  const url = '/api/smartIsland/manage/createSeriesApi'
  return $axios.post(url, data)
}

export function getSeriesList(data) {
  const url = '/api/smartIsland/manage/getSeriesList'
  return $axios.get(url, data)
}

export function updateSeries(data) {
  const url = '/api/smartIsland/manage/updateSeries'
  return $axios.put(url, data)
}

export function delSeries(data) {
  const url = '/api/smartIsland/manage/delSeries'
  return $axios.delete(url, data)
}

export function getCardList(data) {
  const url = '/api/smartIsland/manage/getCardList'
  return $axios.get(url, data)
}

export function createCardApi(data) {
  const url = '/api/smartIsland/manage/createCardApi'
  return $axios.post(url, data)
}

export function updateCard(data) {
  const url = '/api/smartIsland/manage/updateCard'
  return $axios.put(url, data)
}

export function delCard(data) {
  const url = '/api/smartIsland/manage/delCard'
  return $axios.delete(url, data)
}

export function getSupList(data) {
  const url = '/api/smartIsland/manage/getSupList'
  return $axios.get(url, data)
}

export function createSupApi(data) {
  const url = '/api/smartIsland/manage/createSupApi'
  return $axios.post(url, data)
}

export function updateSup(data) {
  const url = '/api/smartIsland/manage/updateSup'
  return $axios.put(url, data)
}

export function delSup(data) {
  const url = '/api/smartIsland/manage/delSup'
  return $axios.delete(url, data)
}

export function resetSupPwdApi(data) {
  const url = '/api/smartIsland/manage/resetSupPwdApi'
  return $axios.put(url, data)
}

export function getBannerApi(data) {
  const url = '/api/smartIsland/manage/getBannerApi'
  return $axios.get(url, data)
}

export function createBannerApi(data) {
  const url = '/api/smartIsland/manage/createBannerApi'
  return $axios.post(url, data)
}

export function updateBannerApi(data) {
  const url = '/api/smartIsland/manage/updateBannerApi'
  return $axios.put(url, data)
}

export function delBannerApi(data) {
  const url = '/api/smartIsland/manage/delBannerApi'
  return $axios.delete(url, data)
}

export function getOrderApi(data) {
  const url = '/api/smartIsland/manage/getOrderApi'
  return $axios.get(url, data)
}

export function createOrderApi(data) {
  const url = '/api/smartIsland/manage/createOrderApi'
  return $axios.post(url, data)
}

export function updateOrderApi(data) {
  const url = '/api/smartIsland/manage/updateOrderApi'
  return $axios.put(url, data)
}

export function startStopOrderApi(data) {
  const url = '/api/smartIsland/manage/startStopOrderApi'
  return $axios.put(url, data)
}

export function delOrderApi(data) {
  const url = '/api/smartIsland/manage/delOrderApi'
  return $axios.delete(url, data)
}

export function getActivityApi(data) {
  const url = '/api/smartIsland/manage/getActivityApi'
  return $axios.get(url, data)
}

export function createActivityApi(data) {
  const url = '/api/smartIsland/manage/createActivityApi'
  return $axios.post(url, data)
}

export function updateActivityApi(data) {
  const url = '/api/smartIsland/manage/updateActivityApi'
  return $axios.put(url, data)
}

export function delActivityApi(data) {
  const url = '/api/smartIsland/manage/delActivityApi'
  return $axios.delete(url, data)
}

export function getFiveActivityListApi(data) {
  const url = '/api/smartIsland/manage/getFiveActivityListApi'
  return $axios.get(url, data)
}

export function getVisitorList(data) {
  const url = '/api/smartIsland/manage/getVisitorList'
  return $axios.get(url, data)
}

// export function createActivityApi(data) {
//   const url = '/api/smartIsland/manage/createActivityApi'
//   return $axios.post(url, data)
// }

export function manageUpdateVisitorStatus(data) {
  const url = '/api/smartIsland/manage/manageUpdateVisitorStatus'
  return $axios.put(url, data)
}

// export function delActivityApi(data) {
//   const url = '/api/smartIsland/manage/delActivityApi'
//   return $axios.delete(url, data)
// }

export function getTranslateUserList(data) {
  const url = '/api/smartIsland/manage/getTranslateUserList'
  return $axios.get(url, data)
}

export function getVisitorActivityList(data) {
  const url = '/api/smartIsland/manage/getVisitorActivityList'
  return $axios.get(url, data)
}


// 获取抽兑换码的抽奖结果列表
export function getVisitorLotteryListApi(params){
    return $axios.get('/api/smartIsland/manage/getVisitorLotteryListApi', params);
}
// export function createActivityApi(data) {
//   const url = '/api/smartIsland/manage/createActivityApi'
//   return $axios.post(url, data)
// }

// export function updateActivityApi(data) {
//   const url = '/api/smartIsland/manage/updateActivityApi'
//   return $axios.put(url, data)
// }

// export function delActivityApi(data) {
//   const url = '/api/smartIsland/manage/delActivityApi'
//   return $axios.delete(url, data)
// }